import { render, staticRenderFns } from "./MetadadosCampoDinamicoHora.vue?vue&type=template&id=0f8b198b"
import script from "./MetadadosCampoDinamicoHora.vue?vue&type=script&lang=js"
export * from "./MetadadosCampoDinamicoHora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports